import { formatDate } from '../helpers/date';

const URL = process.env.REACT_APP_URL_QUOTE_GALENO_WEB;
// const URL = process.env.REAT_APP_URL_QUOTE_GALENO;

const URL_TOKEN = process.env.REACT_APP_URL_TOKEN_GALENO;
const GRANT_TYPE = process.env.REACT_APP_GRANT_TYPE_GALENO;
const USERNAME = process.env.REACT_APP_USER_TOKEN_GALENO;
const PASSWORD = process.env.REACT_APP_PASS_TOKEN_GALENO;

const body = `grant_type=${GRANT_TYPE}&username=${USERNAME}&password=${PASSWORD}`;

export const getToken = async () => {
  const res = await fetch(URL_TOKEN, {
    method: 'POST',
    headers: {
      authorization: `Basic ${process.env.REACT_APP_HEADER_TOKEN_AUTHORIZATION}`,
      'content-type': 'application/x-www-form-urlencoded'
    },
    body: body
  });
  const { access_token } = await res.json();

  return access_token;
};

let data = {
  rama: 4,
  tipoPolizaCodigo: 'AUT01',
  planComercialCodigo: 'GALE',
  tomadorTipoPersona: 1,
  productorCodigo: 74010,
  condicionPagoCodigo: '001',
  modoFacturacionCodigo: '01',
  formaPagoCodigo: 3,
  poseeEquipoGNC: '',
  poseeEquipoRastreo: '',
  subCodigoPostal: '1'
};

export const getQuote = async (car) => {
  data = {
    ...data,
    ceroKM: `${car.zeroKM === '1' ? 'S' : ''}`,
    marcaCodigo: car.brandID,
    modeloCodigo: car.modelID,
    subModeloCodigo: car.versionID,
    anioFabricacion: `${car.year}`,
    codigoPostal: `${car.zipcode}`,
    vigenciaDesde: `${formatDate()}`
  };

  const res = await fetch(`${URL}`, {
    // const res = await fetch(`${url}/cotizar`, {
    method: 'POST',
    headers: {
      // authorization: `Bearer ${localStorage.getItem("token")}`,
      'content-type': 'application/json'
    },
    body: JSON.stringify(data)
  });
  const quote = await res.json();

  return quote;
};
